<mat-form-field class="full-width-field">
  <mat-label>{{ label }}</mat-label>
  <mat-select
    [(ngModel)]="selectedDate"
    name="calendar_date"
    (selectionChange)="onDateChange($event)">
    <mat-option *ngFor="let element of CalendarWeekViewForYearData" [value]="element.key">
      {{ element.value }}
    </mat-option>
  </mat-select>
</mat-form-field>
